var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #222;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.9.2c0,.1.1.2.1.4s0,.3-.1.4l-3.5,3.9c0,.1-.2.2-.4.2s-.3,0-.4-.2L.1.9c0-.1-.1-.2-.1-.4S0,.3.1.2c0-.1.2-.2.4-.2h7c.1,0,.3,0,.4.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.272aeda3298ad51ae021a37469d430b9.svg";
export { ForwardRef as ReactComponent };